import { Dispatch, SetStateAction } from 'react';
import { CardToCardSettings, CashInSettings, OfflineDepositSettings } from 'interfaces';
import { API } from '../data/30pay.api';
import { get, post, postFormData } from 'scripts';

export const _getCashInSettings = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    data: { iBanId?: string; amount?: number; platform: number },
    setData: Dispatch<SetStateAction<CashInSettings | undefined>>,
) => {
    setLoading(true);
    try {
        await post<CashInSettings>(API.transaction.cashInRequest, data).then((response) => {
            setLoading(false);
            setData(response.value.value);
        });
    } catch (error) {
        console.error(error);
    } finally {
        setLoading(false);
    }
};

export const _getCardToCardSettings = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: Dispatch<SetStateAction<CardToCardSettings[] | undefined>>,
) => {
    setLoading(true);
    try {
        await get<CardToCardSettings[]>(API.transaction.cardToCardSettings).then((response) => {
            setLoading(false);
            setData(response.value.value);
        });
    } catch (error) {
        console.error(error);
    } finally {
        setLoading(false);
    }
};

export const _getOfflineDepositSettings = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    data: { cardNumberId?: string; amount?: number },
    setData: Dispatch<SetStateAction<any>>,
) => {
    setLoading(true);
    try {
        await post<OfflineDepositSettings[]>(API.transaction.offlineDepositSettings, data).then((response) => {
            setData(response.value.value);
        });
    } catch (error) {
        console.error(error);
    } finally {
        setLoading(false);
    }
};

export const _deposit = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    data: FormData,
    onComplete: (trackingCode: string, paymentUrl: string) => void,
) => {
    setLoading(true);
    await postFormData<{ trackingCode: string; paymentUrl: string }>(API.transaction.deposit, data)
        .then((response) => {
            const { trackingCode, paymentUrl } = response.value.value;
            onComplete(trackingCode, paymentUrl);
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            setLoading(false);
        });
};
